import type { notifyJobModuleRunningProps } from "./job-module-action-running.type";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";

export const notifyJobModuleRunning = ({
  notify,
  title,
  payload,
}: notifyJobModuleRunningProps) => {
  notify.info({
    key: payload.id,
    title,
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
